var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconHome(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "26px",
    height: "24px",
    viewBox: "0 0 26 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-24.000000, -743.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000, 728.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Tab-1",
    transform: "translate(23.666667, 6.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.1614974,32.165 L21.4948499,32.165 L21.4948499,21.1817542 L24.4987138,21.1857401 L13.324117,10.4011898 L2.14951345,21.1857467 L5.16347193,21.1817568 L5.16347193,32.165 L10.4905208,32.165 L10.4905208,26.9934082 C10.4905208,25.4274113 11.7600122,24.1579199 13.3260091,24.1579199 C14.8920061,24.1579199 16.1614974,25.4274113 16.1614974,26.9934082 L16.1614974,32.165 Z",
    id: "Combined-Shape"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconHome);
export default __webpack_public_path__ + "static/media/icon-home.73d5624a.svg";
export { ForwardRef as ReactComponent };